import React, { useEffect, useState } from "react";
import {
  Box,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
  useTheme,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import FilterPanelActions from "./FilterPanelActions";
import { fieldSx, panelLabelSx } from "./filterPanelStyles";

export default function NaturalLanguagePanel({ naturalQuery, setNaturalQuery, onApply }) {
  const theme = useTheme();
  const [draft, setDraft] = useState(naturalQuery || "");

  useEffect(() => {
    setDraft(naturalQuery || "");
  }, [naturalQuery]);

  const commit = (next = draft) => setNaturalQuery(next);
  const hasValue = Boolean((draft || "").trim());

  return (
    <Box>
      <Typography sx={{ ...panelLabelSx(theme), mb: 0.75 }}>
        Describe the companies you want. Press Enter or the search icon to apply.
      </Typography>
      <TextField
        fullWidth
        id="v2-natural-language-query-autocomplete"
        value={draft}
        onChange={(event) => setDraft(event.target.value)}
        onBlur={() => commit()}
        size="small"
        variant="outlined"
        placeholder="e.g. commercial HVAC contractors in Texas with 50+ employees"
        multiline
        minRows={3}
        autoFocus
        sx={fieldSx(theme)}
        onKeyDown={(event) => {
          if (event.key === "Enter" && !event.shiftKey) {
            event.preventDefault();
            commit();
          }
        }}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end" sx={{ alignSelf: "flex-end", mb: 0.5 }}>
              <IconButton
                type="button"
                onClick={() => commit()}
                edge="end"
                color="primary"
                aria-label="search"
              >
                <SearchIcon />
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
      <FilterPanelActions
        clearDisabled={!hasValue}
        onClear={() => {
          setDraft("");
          setNaturalQuery("");
        }}
        onApply={() => {
          commit();
          onApply?.();
        }}
      />
    </Box>
  );
}
